import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {darkGray} from '/theme/color/on.color';
import {cyanBlue, mineShaft} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  cardContainer: {
    backgroundColor: cyanBlue,
    marginVertical: indent * 0.6,
    marginHorizontal: indent * 0.7,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between', // user wants "justify content space between"
    paddingHorizontal: 16,
  },
  titleText: {
    fontSize: 16,
    color: darkGray,
    marginLeft: 4,
    flexShrink: 1,
  },
  infoIcon: {
    color: mineShaft,
    marginLeft: indent * 0.2,
    fontSize: 17,
  },
  label: {
    fontSize: 16,
    marginLeft: 'auto', // push to right
    marginHorizontal: 4,
    textAlign: 'right',
  },
  centerText: {
    textAlign: 'right',
  },
  popovetTextTitle: {
    fontWeight: '600',
  },
});
